import { highchartsLabelFormatterFromMs, highchartsLabelFormatterWithoutMsFromMs, highchartsCrosshairFormatterFromMs } from '../../utils/dateFormatter';

export const baseChartOptions = {
  accessibility: { enabled: false },
  subtitle: {
    text: ''
  },
  credits: {
    enabled: false
  },
  exporting: {
    menuItemDefinitions: {
      custom: {
        onclick: function () {
          this.fullscreen.toggle();
        },
        text: "Полный экран"
      }
    },
    buttons: {
      contextButton: {
        menuItems: ['custom'],
        x: -25
      }
    }
  }
};

const navigatorOptions = {
  series: {
    type: 'line',
  },
  xAxis: {
    ordinal: false,
    dateTimeLabelFormats: { //was '%M:%S.%L'
      millisecond: '%H:%M:%S',
      second: '%H:%M:%S',
      minute: '%H:%M:%S',
      hour: '%H:%M:%S',
      day: '%H:%M:%S',
      week: '%H:%M:%S',
      month: '%H:%M:%S',
      year: '%H:%M:%S'
    },
    labels: {
      formatter() {
        return highchartsLabelFormatterWithoutMsFromMs(this.value);
      },      
      allowOverlap: false
    }
  },
  //adaptToUpdatedData: false
  stickToMax: false,
  maskFill: 'rgba(102, 133, 194, 0.7)',
  handles: {
    //symbols: ['doublearrow', 'doublearrow'],
    lineWidth: 2,
    width: 7,
    height: 25,
    borderColor: 'darkblue'
  }
};

export const navigationChartOptions = {
  accessibility: { enabled: false },
  chart: {
    height: '100px',
    marginLeft: 75,
    panning: {
      enabled: true,
      type: 'xy'
    },
    panKey: 'shift',
    resetZoomButton: {
      theme: {
        style: {
          display: 'none'
        }
      }
    },    
    zooming: {
      mouseWheel: {
        enabled: false
      }
    }
  },
  navigator: navigatorOptions,
  //https://stackoverflow.com/questions/71499554/is-it-possible-to-independently-use-highcharts-navigator-without-displaying-the
  yAxis: {
    visible: false
  },
  xAxis: {
    visible: false,    
  },
  rangeSelector: {
    enabled: false
  },
  scrollbar: {
    liveRedraw: false,
    barBackgroundColor: '#9b2d30',//'red',
    height: 15,
    barBorderWidth: 7,
    barBorderColor: '#9b2d30'
  },
  legend: {
    enabled: false
  },
  credits: {
    enabled: false
  },
  exporting: {
    enabled: false
  }
};

export const regularChartOptions = {
  accessibility: { enabled: false },
  chart: {
    height: '400px',
    panning: {
      enabled: true,
      type: 'y'
    },
    panKey: 'shift',
    resetZoomButton: {
      theme: {
        style: {
          display: 'none'
        }
      }
    },
    zooming: {
      mouseWheel: {
        enabled: false
      }
    }
  },
  navigator: navigatorOptions,
  xAxis: {
    type: 'datetime',
    tickInterval: 200,
    minorTicks: true,
    minorTickInterval: 40,
    gridLineWidth: 1,
    gridLineColor: '#7cb5ec',
    //gridLineColor: 'red',

    dateTimeLabelFormats: {
      millisecond: '%H:%M:%S.%L',
      second: '%H:%M:%S.%L',
      minute: '%H:%M:%S.%L',
      hour: '%H:%M:%S.%L',
      day: '%H:%M:%S.%L',
      week: '%H:%M:%S.%L',
      month: '%H:%M:%S.%L',
      year: '%Y'
    },
    allowDecimals: true,
    labels: {
      formatter() {        
        return highchartsLabelFormatterFromMs(this.value);
      },
      allowOverlap: false
    },
    crosshair: {
      enabled: true,
      width: 1,
      color: 'gray',
      dashStyle: 'shortdot',
      label: {
        enabled: true,
        formatter: function(value) {
          return highchartsCrosshairFormatterFromMs(value);
        }
      }
    }
  },
  rangeSelector: {
    enabled: false
  },
  tooltip: {
    valueDecimals: 2,
    split: false,
    shared: false,
    useHTML: true,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderWidth: 1,
    borderColor: '#2b5c8a',
    borderRadius: 3,
    padding: 6,
    style: {
      fontSize: '11px'
    },
    formatter: function() {
      const opts = (this.series && this.series.tooltipOptions) || {};
      const decimals = opts.valueDecimals != null ? opts.valueDecimals : 2;
      const prefix = opts.valuePrefix || '';
      const suffix = opts.valueSuffix || '';
      return prefix + this.y.toFixed(decimals) + suffix;
    },
    positioner: function(labelWidth, labelHeight, point) {
      // Position near the data point but offset to not cover it
      const chartX = this.chart.plotLeft + point.plotX;
      const chartY = this.chart.plotTop + point.plotY;

      // Position above and to the right of the point
      return {
        x: chartX + 10,
        y: chartY - labelHeight - 30
      };
    }
  },
  scrollbar: {
    liveRedraw: false,
    barBackgroundColor: '#9b2d30',//'red',
    height: 15,
    barBorderWidth: 7,
    barBorderColor: '#9b2d30'
  },
  plotOptions: {
    series: {
      point: {
        events: {
          //mouseOver: function () { setHoverData(this.category); }
        }
      },
      dataGrouping: {
        enabled: false
      },
      states: {
        inactive: {
          opacity: 1
        }
      }
    }
  },
  legend: {
    enabled: false
  },
  credits: {
    enabled: false
  },
  exporting: {
    menuItemDefinitions: {
      custom: {
        onclick: function () {
          this.fullscreen.toggle();
        },
        text: "Полный экран"
      }
    },
    buttons: {
      contextButton: {
        menuItems: ['custom'],
        x: -25
      }
    }
  }
};

